<div class="lefttrack">
  <div class="btn_tabs" id="topleftbtntabs"[hidden]="!showTabs">
    <button (click)="this.openTabTracking('objects')" *ngIf="visibleComponents.indexOf('objects') >= 0">{{ 'Objects'| translate }}</button>
    <button (click)="this.openTabTracking('geozones')" *ngIf="visibleComponents.indexOf('geozones') >= 0">{{ 'Geozones'| translate }}</button>
    <button (click)="this.openTabTracking('drivers')" *ngIf="visibleComponents.indexOf('drivers') >= 0">{{ 'Drivers'| translate }}</button>
  </div>
  <div class="lefttrack-block">
    <div class="topleft" id="topleft">
      <app-devices-list [trackingMode]="false" *ngIf="visibleComponents.indexOf('objects') >= 0"></app-devices-list>
      <app-geozones-list *ngIf="visibleComponents.indexOf('geozones') >= 0"></app-geozones-list>
      <app-drivers-list *ngIf="visibleComponents.indexOf('drivers') >= 0"></app-drivers-list>
    </div>
    <div (mousedown)="splitterDown()" class="hor_splitter" id="hor_left_splitter"><span></span></div>
    <div class="bottomleft" id="bottomleft">
      <div class="objects" id="objects_bottom">
          <app-device-info-menu [mapMode]="false" [hidden]="!showDeviceMenu"></app-device-info-menu>
        <div class="tablewrap">
          <div class="table">
            <select id="reportslist"></select>
            <div class="reportsettingstab">
              <div class="reportblockheader">{{ 'Report settings'| translate }}</div>
              <div id="reportsettings_options"></div>
            </div>
            </div>
        </div>
        </div>
    </div>
  </div>
</div>
